import React from 'react';
import ReactDOM from 'react-dom';

import './ConfirmDialog.scss';

const ConfirmDialog = ({
	cancelLabel = 'Cancel',
	children = null,
	confirmLabel = 'Confirm',
	confirmVariant = 'danger',
	description = '',
	isOpen = false,
	onCancel,
	onConfirm,
	title = 'Are you sure?'
}) => {
	if (!isOpen) {
		return null;
	}

	const dialog = (
		<div className="cg-confirm-dialog" role="presentation">
			<button
				type="button"
				className="cg-confirm-dialog__backdrop"
				onClick={onCancel}
				aria-label="Close confirmation dialog"
			/>
			<div
				className="cg-confirm-dialog__panel"
				role="dialog"
				aria-modal="true"
				aria-labelledby="cg-confirm-dialog-title"
				aria-describedby={description ? 'cg-confirm-dialog-description' : undefined}
			>
				<h2 id="cg-confirm-dialog-title" className="cg-confirm-dialog__title">
					{title}
				</h2>
				{description && (
					<p id="cg-confirm-dialog-description" className="cg-confirm-dialog__description">
						{description}
					</p>
				)}
				{children && (
					<div className="cg-confirm-dialog__content">
						{children}
					</div>
				)}
				<div className="cg-confirm-dialog__actions">
					<button
						type="button"
						className="cg-confirm-dialog__button cg-confirm-dialog__button--secondary"
						onClick={onCancel}
					>
						{cancelLabel}
					</button>
					<button
						type="button"
						className={`cg-confirm-dialog__button cg-confirm-dialog__button--${confirmVariant}`}
						onClick={onConfirm}
					>
						{confirmLabel}
					</button>
				</div>
			</div>
		</div>
	);

	if (typeof document === 'undefined' || !document.body) {
		return dialog;
	}

	return ReactDOM.createPortal(dialog, document.body);
};

export default ConfirmDialog;
